export const environment = {
  production: false,
  // baseUrl: "http://localhost:3000/",
  // baseUrl: "http://159.89.169.156/api/",
  baseUrl: "https://admin.envirokare.in/api/",
};